import { BoxV2 as Box, Flex } from 'portal-commons';
import { FC } from 'react';

interface SectionTitleProps {
  note?: string;
}

const SectionTitle: FC<SectionTitleProps> = ({ note, children }) => (
  <Flex sx={{ flexDirection: 'column', gap: 'xs', color: 't.black70' }}>
    <Flex
      sx={{
        alignItems: 'center',
        width: '100%',
        height: '32px',
        fontWeight: 600,
        fontSize: 'H500',
        lineHeight: 'normal',
      }}
    >
      {children}
    </Flex>
    {note && <Box sx={{ fontWeight: 400, fontSize: 'H300' }}>{note}</Box>}
  </Flex>
);

export default SectionTitle;
